import { NotificationPayloadT } from 'lib-shared-legacy-types';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { reduxForm } from 'redux-form';

import { withTemplates } from 'hocs';
import { WithTemplatesInjectedProps } from 'hocs/templates/withTemplates';

import { notificationActions } from '../../../../../components/notifications/actions/notification';
import {
  TemplatesAddModalDispatchProps,
  TemplatesAddModalFormValues,
  TemplatesAddModalOwnProps,
  TemplatesAddModalStateProps,
  TemplatesAddModalView,
} from '../../../components/sections/templates/components/templatesAddModal';
import { validate } from '../../../components/sections/templates/components/templatesAddModal/utils';

const mapDispatchToProps = (
  dispatch: Dispatch,
): TemplatesAddModalDispatchProps => ({
  notificationAdd: (payload: NotificationPayloadT) =>
    dispatch(notificationActions.notificationAdd(payload)),
});

const TemplatesAddModalForm = reduxForm<
  TemplatesAddModalFormValues,
  TemplatesAddModalOwnProps &
    TemplatesAddModalStateProps &
    TemplatesAddModalDispatchProps &
    WithTemplatesInjectedProps
>({
  form: 'TemplatesAddModalForm',
  enableReinitialize: true,
  validate,
})(TemplatesAddModalView);

const TemplatesAddModal = withTemplates(TemplatesAddModalForm);

export default connect<
  TemplatesAddModalStateProps,
  TemplatesAddModalDispatchProps,
  TemplatesAddModalOwnProps,
  {}
>(
  undefined,
  mapDispatchToProps,
)(TemplatesAddModal);
